import { Pipe, PipeTransform } from '@angular/core';

// Rich-text values saved through an HTML-escaping path come back as escaped
// markup ("&lt;p&gt;text&lt;/p&gt;"), sometimes several layers deep, and
// [innerHTML] then shows the tags as literal text. Peel escaping layers off
// while the decoded text is itself markup; real HTML passes through unchanged.
@Pipe({ name: 'unescapeHtml' })
export class UnescapeHtmlPipe implements PipeTransform {
  private static readonly MAX_LAYERS = 5;

  transform(value: string): string {
    if (typeof value !== 'string') return '';
    const element = document.createElement('div');
    let html = value;
    for (let i = 0; i < UnescapeHtmlPipe.MAX_LAYERS; i++) {
      element.innerHTML = html;
      const text = element.textContent || '';
      if (!/<\/?[a-z][^>]*>/i.test(text)) break;
      html = text;
    }
    return html;
  }
}
